<template>
  <editor :init="setting" v-model="editorData.content" />
</template>

<script>
import tinymce from "tinymce/tinymce";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons.min.js";
import Editor from "@tinymce/tinymce-vue";

import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/lists";
import "tinymce/plugins/preview";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/charmap";
export default {
  name: "TinymceEditor",
  components: {
    editor: Editor,
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    editorData: {
      type: Object,
      default: () => {
        return {
          content: "",
        };
      },
    },
  },
  data() {
    return {
      editorContent: this.content,
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      setting: {
        height: this.height,
        language_url: "/static/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/ui/oxide",
        content_style: "p {margin-top: 1.5rem;}",
        menubar: false,
        forced_root_block: "p",
        force_p_newlines: true,
        plugins: [
          "link image",
          "code wordcount, charmap",
          "lists preview, insertdatetime",
        ],
        toolbar:
          "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist charmap	outdent indent  \
          | removeformat preview code	",
        valid_elements: "*[*]",
      },
    };
  },
  mounted() {
    tinymce.init({});
  },
};
</script>

<style>
.tox-tinymce-aux {
  z-index: 5000 !important;
}
</style>
